module.exports = __webpack_public_path__ + "img/banner.333880d1.png";